module.exports = __webpack_public_path__ + "static/img/3.b454139.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/sp/3.png
// module id = YrF8
// module chunks = 0